module.exports = __webpack_public_path__ + "static/media/running-small.dce882f1.gif";